import { $api } from '@shared/api';
import { IReturnResponse } from '@widgets/Files/model/types/api.interface';
import { TFileId } from '@widgets/Files/model/types/fileId.type';
import { TFolderId } from '@widgets/Files/model/types/folderId.type';

interface IMoveFileParams {
    objectId: string;
    type: 'folder' | 'file';
    moveToId: TFolderId | 'default';
}

export const moveObject = async ({ objectId, type, moveToId }: IMoveFileParams) => {
    // @ts-ignore
    const route = routable.getRoute('moveObject');
    try {
        const formData = new FormData();
        formData.append('object', objectId);
        formData.append('type', type);
        formData.append('move_to', String(moveToId));
        const { data } = await $api.post<IReturnResponse>(route, formData);
        return data;
    } catch (error) {
        console.error('move file failed:', error);
        return (
            error?.response?.data || {
                status: 'error',
                data: null,
                message: error.message,
            }
        );
        // return {
        //     status: 'error',
        //     data: null,
        //     message: error.message,
        // };
    }
};
